module.exports = __webpack_public_path__ + "img/icon-delivery-bike.35ee0ec6.svg";